/**
 * Created by renjie.huang on 2017/11/10.
 */

import React from 'react';
import _ from "_";
import {
    Input,
    Icon,
    Tooltip
  } from "@ucloud-fe/react-components";
import strength from '../../common/strength';
import localeService from '../../service/localeService';
import { PopPassTip } from './style.jsx';
import { isMobile } from "../../service/deviceDetectService";


class RegisterPassword extends React.Component{
    constructor(props){
        super(props);
        var self = this;
        self.state = {
            type : 'password',
            value : '',
            strength : 0,
            strengthText : "",
        }

    }


    onEyeClick(){
        var _type = this.state.type === 'password' ? 'text' : 'password';
        this.setState({
            type : _type
        })
    }

    get value(){
        return this.state.value;
    }

    passwordChange(event){
        var self = this;
        const { needStrength } = this.props;
        var _value = event.target.value;
        self.setState({
            value : _value
        })
        self.props.onChange(_value);
        if(!!needStrength){
            var _strength = strength(_value);
            var _copy = self.getStrengthCopy(_strength);
            self.setState({
                strength : _strength,
                strengthText : _copy
            })
            self.props.onStrengthChange(_strength)
        }
    }

    getStrengthCopy(strength){
        switch (strength){
            case -1 :
                return localeService.getTranslate('LOGIN40');
            case -2 :
                return localeService.getTranslate('LOGIN41');
                
            case 1:
                return localeService.getTranslate('LOGIN35');
            case 2:
                return localeService.getTranslate('LOGIN36');
            case 3:
                return localeService.getTranslate('LOGIN36');
            case 4:
                return localeService.getTranslate('LOGIN37');
            default :
                return localeService.getTranslate('LOGIN34');
        }
    }

    render(){
        var self = this;
        const { type, strength, value, strengthText } = this.state;
        const { needTip=true, className, needStrength, placeholder  } = this.props;
        var _icon = type === 'password' ? 'uc-input__icon icon__closeeye' : 'uc-input__icon icon__eye';
        var _clsName = className ? className : '';
        var _strengthClass = `pws-strength pwd-strength-${strength}`;
        var _passwordClassName = `pwd-rule u-mt10 pwd-rule-${strength}`;
        var _error = (needStrength && strength < 2 && strength !=0 ) ? true : false;

        return <div className="app-form-item">
                    <Tooltip 
                    trigger={[needTip ? 'focus' : undefined]} 
                    arrow={false} 
                    placement={isMobile() ? "bottom" : "right"} 
                    popup={
                        <PopPassTip>
                            {localeService.getTranslate('LOGIN34')}
                        </PopPassTip>
                    }
                    getPopupContainer ={() => document.body}
                    >
                      <Input 
                            onFocus={this.props.onFocus.bind(this)}  
                            value={value} size="lg"
                            type={type} className={_clsName}
                            //  prefix={<Icon type="lock"></Icon>}
                            autoComplete="on"
                            maxLength="21"
                            placeholder={placeholder}
                            onBlur={this.props.onBlur.bind(this)}
                            onChange={this.passwordChange.bind(this)}
                            onKeyDown={this.props.onKeyDown.bind(this)}
                            suffix={<Icon onClick={this.onEyeClick.bind(this)}
                            type={_icon}></Icon>}></Input>
                    </Tooltip>
                      {
                            !!needStrength ? <div className={_strengthClass}></div> : false
                      }
                     
                      {
                            !!needStrength && _error ? <p className={_passwordClassName}>{strengthText || localeService.getTranslate('LOGIN34')}</p> : false
                      }
               </div>
    }
}

RegisterPassword.defaultProps = {
    onKeyDown: ()=>{},
    onChange : ()=>{},
    onBlur : ()=>{},
    onStrengthChange : ()=>{},
    onFocus : ()=>{}
}

export default RegisterPassword;


// WEBPACK FOOTER //
// src/pc/components/Password.js